function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "path-1",
  cx: 68.5999988,
  cy: 60.199999,
  r: 58.799999
}), React.createElement("linearGradient", {
  x1: "158.881532%",
  y1: "67.4782887%",
  x2: "21.3173604%",
  y2: "40.9670967%",
  id: "linearGradient-3"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "7.46863097%",
  y1: "3.13526376%",
  x2: "78.3005242%",
  y2: "86.3220189%",
  id: "linearGradient-4"
}, React.createElement("stop", {
  stopColor: "#F49593",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#F7BF28",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "89.3236703%",
  y1: "46.5396733%",
  x2: "-36.8982258%",
  y2: "53.6523009%",
  id: "linearGradient-5"
}, React.createElement("stop", {
  stopColor: "#7E2889",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#1587C8",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "89.3236703%",
  y1: "49.3286299%",
  x2: "-38.482994%",
  y2: "50.7086168%",
  id: "linearGradient-6"
}, React.createElement("stop", {
  stopColor: "#7E2889",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#1587C8",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "125.084216%",
  y1: "45.4073717%",
  x2: "21.4106793%",
  y2: "53.7012671%",
  id: "linearGradient-7"
}, React.createElement("stop", {
  stopColor: "#F09724",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E81C69",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "125.084216%",
  y1: "47.0928959%",
  x2: "21.4106793%",
  y2: "52.3428782%",
  id: "linearGradient-8"
}, React.createElement("stop", {
  stopColor: "#F09724",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E81C69",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "125.084216%",
  y1: "45.5645254%",
  x2: "21.4106793%",
  y2: "53.5746146%",
  id: "linearGradient-9"
}, React.createElement("stop", {
  stopColor: "#F09724",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#E81C69",
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "07-desktop-UI",
  transform: "translate(-178.000000, -315.000000)"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(171.000000, 314.000000)"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1"
})), React.createElement("use", {
  id: "Mask-Copy",
  fill: "#F1F1F1",
  fillRule: "nonzero",
  xlinkHref: "#path-1"
}), React.createElement("rect", {
  id: "Rectangle-33",
  fill: "url(#linearGradient-3)",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 31.4999995,
  y: 33.5999994,
  width: 95.8999984,
  height: 56.699999,
  rx: 7.69999987
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "url(#linearGradient-4)",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 39.1999993,
  y: 54.5999991,
  width: 14.6999997,
  height: 14.6999997,
  rx: 2.09999996
}), React.createElement("rect", {
  id: "Rectangle-34",
  fill: "url(#linearGradient-5)",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 63.6999989,
  y: 58.799999,
  width: 25.8999996,
  height: 6.99999988,
  rx: 3.49999994
}), React.createElement("rect", {
  id: "Rectangle-34-Copy-2",
  fill: "url(#linearGradient-6)",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 63.6999989,
  y: 71.3999988,
  width: 58.799999,
  height: 6.99999988,
  rx: 3.49999994
}), React.createElement("g", {
  id: "Group-2",
  transform: "translate(23.315263, 22.290193) scale(-1, 1) rotate(130.000000) translate(-23.315263, -22.290193) translate(11.315263, 2.290193)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M8.80833786,4.43796625 L20.5035592,4.43796625 C21.8950644,4.43796625 23.0231022,5.56600409 23.0231022,6.95750927 L23.0231022,6.99012126 C23.0231022,8.38162645 21.8950644,9.50966428 20.5035592,9.50966428 L8.80833786,9.50966428 C7.41683268,9.50966428 6.28879485,8.38162645 6.28879485,6.99012126 L6.28879485,6.95750927 C6.28879485,5.56600409 7.41683268,4.43796625 8.80833786,4.43796625 Z",
  id: "Rectangle-10",
  fill: "url(#linearGradient-7)",
  transform: "translate(14.655949, 6.973815) rotate(30.000000) translate(-14.655949, -6.973815) "
}), React.createElement("path", {
  d: "M2.51954302,17.4867922 L18.51379,17.4867922 C19.9052951,17.4867922 21.033333,18.61483 21.033333,20.0063352 L21.033333,20.0389472 C21.033333,21.4304524 19.9052951,22.5584902 18.51379,22.5584902 L2.51954302,22.5584902 C1.12803783,22.5584902 3.63681695e-12,21.4304524 3.63797881e-12,20.0389472 L3.63797881e-12,20.0063352 C3.63736431e-12,18.61483 1.12803783,17.4867922 2.51954302,17.4867922 Z",
  id: "Rectangle-10-Copy",
  fill: "url(#linearGradient-8)"
}), React.createElement("path", {
  d: "M8.53414695,30.6090873 L20.5232452,30.6090873 C21.9147504,30.6090873 23.0427883,31.7371251 23.0427883,33.1286303 L23.0427883,33.1612423 C23.0427883,34.5527475 21.9147504,35.6807853 20.5232452,35.6807853 L8.53414695,35.6807853 C7.14264176,35.6807853 6.01460393,34.5527475 6.01460393,33.1612423 L6.01460393,33.1286303 C6.01460393,31.7371251 7.14264176,30.6090873 8.53414695,30.6090873 Z",
  id: "Rectangle-10-Copy-2",
  fill: "url(#linearGradient-9)",
  transform: "translate(14.528696, 33.144936) rotate(-30.000000) translate(-14.528696, -33.144936) "
})))));

var SvgIban = function SvgIban(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 118",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIban, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iban.3badc68c.svg";
export { ForwardRef as ReactComponent };